module.exports = __webpack_public_path__ + "img/zhorsena.89521c2b.svg";